import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'alert',

  imports: [MatIconModule],
  templateUrl: './alert.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './alert.component.scss',
})
export class AlertComponent {
  @Input() title: string;
  @Input() variant: 'info' | 'success' | 'warn' | 'error' | 'surface' = 'info';
  @Input() genre: 'regular' | 'muted' = 'regular';
  @Input() icon: string;
  @Input() hasIcon = true;

  public backgroundColor: string;

  public color: string;

  ngOnInit() {
    if (this.variant === 'surface') {
      if (this.genre === 'muted') {
        this.backgroundColor = `var(--mat-sys-surface-container)`;
      } else {
        this.backgroundColor = `var(--mat-sys-inverse-surface)`;
      }
    } else {
      this.backgroundColor = `var(--mat-sys-${this.variant}${this.genre === 'muted' ? '-container' : ''})`;
    }
    this.color = this._color();
  }

  private _color() {
    if (this.variant === 'surface') {
      if (this.genre === 'muted') {
        return `var(--mat-sys-on-surface)`;
      } else {
        return `var(--mat-sys-inverse-on-surface)`;
      }
    }

    return `var(--mat-sys-on-${this.variant}${this.genre === 'muted' ? '-container' : ''})`;
  }
}
